import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderColor } from '@ionic-native/header-color/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { MenuController, Platform, PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { environment } from 'src/environments/environment';
import { LangProvider } from './modules/lang/lang.provider';
import { ProfilePopoverComponent } from './private/components/profile-popover/profile-popover.component';
import { UpdatemodalPage } from './private/pages/common-module/pages/updatemodal/updatemodal';
import { MenuItems, PageInterface } from './services/config/menu';
import { CoreProvider } from './services/core';

@Component({
  selector: 'app-root',
  styleUrls: ['app.component.scss'],
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {

  isLangLoaded: boolean = false;
  menuModel = MenuItems;
  isBrowser: boolean = false;
  menuOpen: boolean = true;

  constructor(
    public core: CoreProvider,
    public menu: MenuController,
    private storage: Storage,
    private platform: Platform,
    private headerColor: HeaderColor,
    private splashScreen: SplashScreen,
    private router: Router,
    private popoverCtrl: PopoverController
  ) {
    const startLang = localStorage.getItem('langCode') || 'es';
    LangProvider.singleton.setLanguage(startLang, () => {
      this.isLangLoaded = true;
    });
    // Init core
    this.core.version.config.updateModal = UpdatemodalPage;

    if (!environment.production) this.core.version.config.updateIntervalDelay = 10000;

    this.menuOpen = localStorage.getItem('menu-open') == 'true';
    this.menuModel.forEach(e => {
      if (e.header) {
        e['expanded'] = localStorage.getItem('menu-expanded-' + e.header) == 'true';
      }
    });

    this.platformReady();
  }

  async ngOnInit() {
    // If using a custom driver:
    // await this.storage.defineDriver(MyCustomDriver)
    await this.storage.create();
  }

  logout() {
    this.core.auth.logout(() => {
      // this.core.setRoot(LoginPage, {});
      this.router.navigateByUrl('/login');
    });
  }

  platformReady() {
    this.platform.ready().then(p => {
      this.splashScreen.hide();
      this.headerColor.tint('#488aff');
    });
  }

  isActive(page: PageInterface) {
    if (this.router && this.router.isActive(page.url, true)) {
      return "selected-icon";
      // return page.color ? page.color : 'icons';
    }
    return;
  }

  hasActiveChilds(sectionItems: PageInterface[]): boolean {
    for (let i = 0; i < sectionItems.length; i++) {
      if (this.core.isShowed(sectionItems[i])) return true;
    }
    return false;
  }

  updateModal = () => UpdatemodalPage.Open(this.core);

  async toggleMenu(menu:'menu'='menu') {
    if (window.innerWidth < 800) {
      this.menuOpen = await this.menu.isOpen(menu);
    }

    await this.menu[this.menuOpen ? 'close' : 'open'](menu);
    this.menuOpen = !this.menuOpen;
    localStorage.setItem('menu-open', this.menuOpen.toString());
  }

  toggleHeader(s: { header: string, expanded?: boolean }) {
    s['expanded'] = !s['expanded'];
    console.log(s);
    localStorage.setItem('menu-expanded-' + s.header, s['expanded'].toString());
  }

  async presentPopover(e: any) {
    const popover = await this.popoverCtrl.create({
      component: ProfilePopoverComponent,
      event: e,
      cssClass: "my-popover"
    });
    await popover.present();
  }
}
